// Auto-generated by scripts/generate-version.ts
export const APP_VERSION = '695e93c';
